import React from "react";
import {Redirect} from "react-router";
//import ReactDOM from "react-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import DoctorSubsribeForm from "components/Forms/DoctorForm/AddExistingForm.jsx";
import DoctorForm from "components/Forms/DoctorForm/DoctorForm.jsx";
import SearchComponent from "components/Search/AutoCompleteComponent.jsx";

//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import api from "../../api/Api";
import {dashboardRouter} from "../../util/globalHelper";


const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    }
};

class AddDoctor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addNew: false,
            addExisting: false,
            alert: null,
            open: "true",
            selected_doctorID: '',
            subscription: 'notdone',
            clinicmaster_id: "",
            clinic_id: ""
        }
        this.getSuggestionValue = this.getSuggestionValue.bind(this);
        this.addNewClick = this.addNewClick.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.checkSubscription = this.checkSubscription.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this);
    };


    changeSubscriptionState(value) {
        this.setState({subscription: value});
    }


    getSuggestionValue = (suggestion) => {
        this.props.match.params.clinicID ? this.checkSubscription(this.props.match.params.clinicID, suggestion._id, function (subscribed) {
            if (subscribed === "no") {
                this.setState({selected_doctorID: suggestion._id});
                this.setState({
                    selected_doctorID: suggestion._id,
                    subscription: "notdone",
                    addExisting: true,
                    addNew: false
                });
                this.props.history.push(dashboardRouter(`/doctor/updateDoctorDetails/${suggestion._id}/${this.props.match.params.clinicID}`));
            }
            else {
                this.setState({subscription: "done"});
                var msg = {message: "Doctor already subscribed! Please select another Doctor.", color: "danger"};
                this.props.generateNotification(msg)
                // this.CreateAlert(msg);
            }
        }.bind(this)) : this.props.history.push(dashboardRouter(`/doctor/oneDoctor/${suggestion._id}`));
        return suggestion.user_id.name
    }

    componentDidMount() {
        this.props.match.params.clinicmasterID ?
            this.setState({
                clinicmaster_id: this.props.match.params.clinicmasterID,
                clinic_id: this.props.match.params.clinicID
            }) : this.setState({dropdown: true})
    }


    hideAlert() {
        this.setState({
            alert: null
        });
    }


    CreateAlert(reason) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{reason}</DialogTitle>

                    <DialogActions>
                        <Button onClick={this.hideAlert}>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }


    checkSubscription(clinicId, doctorId, callback) {
        var data = {doctor_id: doctorId, clinic_id: clinicId};
        api.checkDoctorSubscription(data).then(response => {
            if (!response) {
                var reason = "BAD REQUEST! ";
                this.CreateAlert(reason);
            } else {
                return response.data;
            }
        }).then(json => {
            if (json.status === "failed") {
                var reason = json.reason;
                this.CreateAlert(reason);
            } else {
                if (json.data === "subscribed") {
                    callback("yes")
                } else {
                    callback("no")
                }
            }
        });
    }

    addNewClick() {
        this.setState({addExisting: false, addNew: true});
    }

    render() {
        const {classes} = this.props;
        return (
            <div>
                {this.state.alert}
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" text>
                                <CardText color="info">
                                    <h4 className={classes.cardTitle}>Add Doctor</h4>
                                </CardText>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} md={12} sm={12}>
                                        <GridContainer>
                                            <GridItem xs={12} md={5} sm={6}>
                                                <SearchComponent id={this.props}
                                                                 getSuggestionValue={this.getSuggestionValue}/>
                                            </GridItem>
                                            <GridItem xs={12} md={1} sm={1} className={classes.justifyContentCenter} style={{textAlign: "center"}}>
                                            <h4>OR</h4>
                                            </GridItem>
                                            <GridItem xs={12} md={4} sm={4}>
                                                <Button block color="warning" onClick={this.addNewClick}>Add New</Button>
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                    {this.state.addExisting ? (<GridItem xs={12} md={12} sm={12}>
                                        <DoctorSubsribeForm id={this.props} doctorId={this.state.selected_doctorID}
                                                            subscription={this.state.subscription}
                                                            changeSubscriptionState={this.changeSubscriptionState}/>
                                    </GridItem>) : null
                                    }
                                    {this.state.addNew ? (<GridItem xs={12} md={12} sm={12}>
                                        <DoctorForm clinic_id={this.state.clinic_id}
                                                    clinicmaster_id={this.state.clinicmaster_id}
                                                    id={this.props}/>
                                    </GridItem>) : null
                                    }
                                </GridContainer>
                                <GridContainer>
                                    <br /><br />
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>);
    }

}

export default withStyles(styles)(AddDoctor);



// WEBPACK FOOTER //
// ./src/views/Doctors/addDoctor.jsx